export const PARTNER_CONTACT = {
  UPDATE_NUMBER: "UPDATE_NUMBER",
  SPINNER: "SPINNER",
  OPEN_VERIFICATION_MODAL: "OPEN_VERIFICATION_MODAL",
  PHONE_NUMBER: "PHONE_NUMBER"
};
